import { State } from '../../../store/state';

export const classesSelector = (state: State) => state.class.classes;
export const classSelector = (state: State) => state.class.class;
export const optionsSelector = (state: State) => state.class.options;
export const errorCodeSelector = (state: State) => state.class.errorCode;
